import { render, staticRenderFns } from "./BizOrderEdit.vue?vue&type=template&id=d0dc32e2"
import script from "./BizOrderEdit.vue?vue&type=script&lang=js"
export * from "./BizOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports